export default {
  gridcontextmenu: {
    gridContextMenuModal: {
      header: "Вид",
      menu: {
        full: "Полный",
        optimal: "Оптимальный",
        load: "Загрузить мои настройки",
        save: "Сохранить мои настройки"
      },
      stateApplied: {
        loadSuccess: "Настройки успешно загружены",
        saveSuccess: "Настройки успешно сохранены",
        loadError: "Нет сохраненных настроек"
      }
    }
  }
};
